import {
  LEGACY_ANALYTICS_BASE_PATH,
  TRADING_ANALYTICS_BASE_PATH,
  type AnalyticsBasePath,
} from '@src/tokens/navigationPaths';
import { useLocation } from 'react-router-dom';
import { useFeatureFlag } from './useFeatureFlag';

export function getAnalyticsBasePath(enableAnalyticsInTrading: boolean): AnalyticsBasePath {
  return enableAnalyticsInTrading ? TRADING_ANALYTICS_BASE_PATH : LEGACY_ANALYTICS_BASE_PATH;
}

export function useAnalyticsBasePath(): AnalyticsBasePath {
  const { enableAnalyticsInTrading, isLoaded } = useFeatureFlag();
  const { pathname } = useLocation();

  if (!isLoaded && pathname.startsWith(TRADING_ANALYTICS_BASE_PATH)) {
    return TRADING_ANALYTICS_BASE_PATH;
  }

  return getAnalyticsBasePath(enableAnalyticsInTrading);
}
